import transformString from './transformString';

const months: any = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec'
];

const fixedTime: any = {
  '00': '12',
  '13': '01',
  '14': '02',
  '15': '03',
  '16': '04',
  '17': '05',
  '18': '06',
  '19': '07',
  '20': '08',
  '21': '09',
  '22': '10',
  '23': '11',
  '24': '12'
};

const formatDate = (
  dateString: string | Date,
  type: 'month-time' | 'time' | 'date' | 'year-month-time' | 'date-month' | 'yyyy-mm-dd' | 'dd-mm-yyyy'= 'date' 
) : any => {
  if (typeof dateString !== 'string') {
    return '';
  }
  /** Modifying date to current timezone */
  let date = new Date(dateString);
  let offset = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();

  let split: any = offset.split('T')[0].split('-');
  let dateSplit: any = date.toISOString().split('T')[0].split('-');
  let time: Array<string> = offset.split('T')[1].split(':');

  if (type === 'date-month'){
    const dSplit = date.toISOString().split('T')[0].split('-')
    return (
      dSplit[2] + '-' + months[parseInt(transformString(dSplit[1], '0', '')) - 1] + '-' + dSplit[0]
    );
  }
  if (type === 'yyyy-mm-dd'){
    const dSplit = date.toISOString().split('T')[0].split('-')
    console.log(dSplit);
    return (
      dSplit[0] + '-' + dSplit[1] + '-' + dSplit[2]
    );
  }
  if (type === 'date')
    return (
      split[2] + '-' + months[parseInt(transformString(split[1], '0', '')) - 1] + '-' + split[0]
    );




   if (type === 'dd-mm-yyyy'){
     let formatted = time[0];
    let tmz = 'AM';
    if (parseInt(time[0]) > 12) {
      formatted = fixedTime[time[0]];
      tmz = 'PM';
    }
    return (
      split[2] + '-' + split[1] + '-' + split[0] +
      ', ' +
      `${formatted}:${time[1]} ${tmz}`
    );
  }

  if (type === 'month-time') {
    let formatted = time[0];
    let tmz = 'AM';
    if (parseInt(time[0]) > 12) {
      formatted = fixedTime[time[0]];
      tmz = 'PM';
    }
    return (
      split[2] +
      ' ' +
      months[parseInt(transformString(split[1], '0', '')) - 1] +
      ', ' +
      `${formatted}:${time[1]} ${tmz}`
    );
  }

  if (type === 'year-month-time') {
    // let formatted = date.toISOString().split('T')[1].split(':')[0];
    let fTime =  date.toISOString().split('T')[1].split(':');
    // let tmz = 'AM';

    // if (parseInt(fTime[0]) > 12) {
    //   formatted = fixedTime[fTime[0]];
    //   tmz = 'PM';
    // }
    let formatted = time[0];
    let tmz = 'AM';
    if (parseInt(time[0]) > 12) {
      formatted = fixedTime[time[0]];
      tmz = 'PM';
    }
    return (
      date.toISOString().split('T')[0].split('-')[2] +
      ' ' +
      months[parseInt(transformString(split[1], '0', '')) - 1] +
      ' ' +
      date.toISOString().split('T')[0].split('-')[0] +
      ' ' +
      `${formatted}:${time[1]} ${tmz}`
    );
  }

  if (type === 'time') {
    let formatted = offset.split('T')[1].split(':')[0];

    let tmz = 'AM';
    if (parseInt(time[0]) > 12) {
      formatted = fixedTime[offset.split('T')[1].split(':')[0]];
      tmz = 'PM';
    }
    return `${formatted}:${time[1]} ${tmz}`;
  }
};

export default formatDate;